module.exports = __webpack_public_path__ + "static/img/zhongfu.b65a175.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongfu.png
// module id = 90o+
// module chunks = 0